import { Checkbox, FormControl, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { MenuProps } from '../muiStyle/muiStyle'
import { AuctionBase } from '../../../app/models/Auction'

interface Props {
  auction: AuctionBase
  userStore: any
  handleChange: any
}

function ModeratorsSelect({ auction, userStore, handleChange }: Props) {
  const { t } = useTranslation()
  return (
    <FormControl className='auction-create-mods-select' sx={{ mb: 1, width: '100%' }}>
      <label>{t('moderators')}</label>
      <Select
        id='demo-multiple-checkbox'
        className='select-border'
        displayEmpty
        multiple
        value={auction.authorizedMods}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return t('select_mods')
          }

          return selected.join(', ')
        }}
        MenuProps={MenuProps}
      >
        <MenuItem disabled value=''>
          <em>{t('select_mods')}</em>
        </MenuItem>
        {userStore.moderators?.map((name: any) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={auction.authorizedMods!.indexOf(name) > -1} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
export default ModeratorsSelect
